import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { Paragraph } from 'components/patterns/Typography'

const OutputTypeNativeDescriptionLabel = ({
  outputDescription,
  description,
}) => (
  <Paragraph size="small">
    {strings.native_output}: <strong>{outputDescription || `Undefined`}</strong>
  </Paragraph>
)

OutputTypeNativeDescriptionLabel.propTypes = {
  fnId: PropTypes.string,
  outputDescription: PropTypes.string,
  description: PropTypes.string,
}

export default OutputTypeNativeDescriptionLabel
